import * as Ariakit from '@ariakit/react'

interface TooltipProviderProps extends Omit<Ariakit.TooltipProviderProps, 'store'> {
  state?: Ariakit.TooltipProviderProps['store']
}

export function TooltipProvider({ state, ...props }: TooltipProviderProps) {
  return <Ariakit.TooltipProvider store={state} showTimeout={0} hideTimeout={0} {...props} />
}
